import { render, staticRenderFns } from "./SpeechTextButton.vue?vue&type=template&id=2e7747a4&scoped=true&lang=pug&"
import script from "./SpeechTextButton.vue?vue&type=script&lang=ts&"
export * from "./SpeechTextButton.vue?vue&type=script&lang=ts&"
import style0 from "./SpeechTextButton.vue?vue&type=style&index=0&id=2e7747a4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7747a4",
  null
  
)

export default component.exports